import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PaginatedResponseModel} from '../../models/paginated.response.model';
import {WebchargeStatus} from './webchargeStatus.enum';
import {WebchargeListModel} from './webchargeList.model';
import {WebchargeModel} from './webcharge.model';

@Injectable({
  providedIn: 'root'
})
export class WebchargeService {
  constructor(private http: HttpClient) {
  }

  getPaginated(page: number, size: number, reference: string, cardNumber: string, status: WebchargeStatus):
    Observable<PaginatedResponseModel<WebchargeListModel>> {
    const params: {
      page: string,
      size: string,
      reference?: string,
      cardNumber?: string,
      status?: WebchargeStatus
    } = {
      page: page.toString(),
      size: size.toString(),
    };
    if (reference) {
      params.reference = reference;
    }
    if (cardNumber) {
      params.cardNumber = cardNumber;
    }
    if (status) {
      params.status = status;
    }

    return this.http.get<PaginatedResponseModel<WebchargeListModel>>(`/v2/admin/webcharge`, {params});
  }

  getDetailsById(reference: string): Observable<WebchargeModel> {
    return this.http.get<WebchargeModel>(`/v2/admin/webcharge/${reference}`);
  }
}
